import styled from 'styled-components';
export const WrapperCard_Hover = styled.div`
  opacity: 0;
  width: 90%;
  height: 90%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 5;
`;
export const WrapperCard = styled.div`
  background-image: url(${(props) => props.bg});
  background-size: cover;
  background-position: center;
  width: 300px;
  position: relative;
  height: 225px;
  border-radius: 5px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
  transition: all 0.3s ease-in-out;
  margin: 0 10px;
  margin-top: 1.5rem;
  &:hover::after {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 90%;
    height: 90%;
    background-color: rgba(0, 0, 0, 0.5);
    border-radius: 5px;
  }
  &:hover ${WrapperCard_Hover} {
    opacity: 1;
  }
  &.animate__zoomOut {
    display: none;
    @keyframes zoomOut {
      0% {
        transform: scale(1);
        width: 90%;
        height: 90%;
        
      }
      100% {
        transform: scale(0);
        width: 0;
        height: 0;
      }
`;
export const WrapperImage = styled.img`
  width: 100%;
  height: 100%;
  border-radius: 5px;
  position: absolute;
  top: 0;
  left: 0;
  object-fit: cover;
`;

export const Head_5 = styled.h5`
  font-size: 2.5rem;
  font-weight: bold;
  text-align: center;
  margin-bottom: 1rem;
  color: #fff;
`;
export const Link = styled.a`
  cursor: pointer;
  font-size: 2.5rem;
  color: #4e6e29;
  text-decoration: none;
  & > svg {
    cursor: pointer;
  }
`;
